import { Bell, BookOpen, House, MessageCircle, SquarePen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type TabBarActive = 'home' | 'chat' | 'calendar' | 'note' | 'bell';

export interface TabBarProps {
  active?: TabBarActive;
}

function CalendarTabIcon({ active }: { active: boolean }) {
  if (active) {
    // Phosphor-style filled calendar: solid body with two notch cutouts.
    return (
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
        <rect x='3' y='4' width='18' height='17' rx='4' fill='currentColor' />
        <rect x='7.1' y='2.6' width='2.2' height='4.2' rx='1.1' fill='#f5f9fa' />
        <rect x='14.7' y='2.6' width='2.2' height='4.2' rx='1.1' fill='#f5f9fa' />
      </svg>
    );
  }
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
      <rect
        x='3.5'
        y='4.5'
        width='17'
        height='15.5'
        rx='3.5'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path
        d='M8 3v3M16 3v3'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
}

const TABS: ReadonlyArray<{
  key: TabBarActive;
  icon?: LucideIcon;
  activeIcon?: LucideIcon;
}> = [
  { key: 'home', icon: House },
  { key: 'chat', icon: MessageCircle },
  { key: 'calendar' },
  // The app's note tab reads as a pencil-in-square at rest and a filled
  // book-like glyph when active (Phosphor edit-note light vs fill).
  { key: 'note', icon: SquarePen, activeIcon: BookOpen },
  { key: 'bell', icon: Bell },
];

export function TabBar({ active = 'home' }: TabBarProps) {
  return (
    <nav className='mk-tabbar' aria-hidden='true'>
      {TABS.map(({ key, icon, activeIcon }) => {
        const isActive = key === active;
        const Icon = isActive ? (activeIcon ?? icon) : icon;
        return (
          <span
            key={key}
            className={`mk-tabbar__item${isActive ? ' is-active' : ''}`}
          >
            {Icon ? (
              <Icon
                size={24}
                strokeWidth={2}
                fill={isActive && key === 'home' ? 'currentColor' : 'none'}
              />
            ) : (
              <CalendarTabIcon active={isActive} />
            )}
          </span>
        );
      })}
    </nav>
  );
}
